// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file preview.proto (package cryptotrader, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { BacktestResultSchema } from "./backtest_pb";
import { file_backtest } from "./backtest_pb";
import type { EmptySchema } from "./common_pb";
import { file_common } from "./common_pb";
import type { ConfigurableListSchema, GetParamsRequestSchema, ParamsResponseSchema, ProviderConfig, ProviderConfigSchema, ProviderInfosResponseSchema, ValidateResponseSchema } from "./configurable_pb";
import { file_configurable } from "./configurable_pb";
import type { SymbolsResponseSchema, TimeframesResponseSchema } from "./market_pb";
import { file_market } from "./market_pb";
import type { StrategyInfoResponseSchema } from "./strategy_pb";
import { file_strategy } from "./strategy_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file preview.proto.
 */
export const file_preview: GenFile = /*@__PURE__*/
  fileDesc("Cg1wcmV2aWV3LnByb3RvEgxjcnlwdG90cmFkZXIiSAoWR2V0U3RyYXRlZ3lJbmZvUmVxdWVzdBIuCghzdHJhdGVneRgBIAEoCzIcLmNyeXB0b3RyYWRlci5Qcm92aWRlckNvbmZpZyL3AgoWUHJldmlld0JhY2t0ZXN0UmVxdWVzdBIsCgZtYXJrZXQYASABKAsyHC5jcnlwdG90cmFkZXIuUHJvdmlkZXJDb25maWcSDgoGc3ltYm9sGAIgASgJEhEKCXRpbWVmcmFtZRgDIAEoCRIuCghzdHJhdGVneRgEIAEoCzIcLmNyeXB0b3RyYWRlci5Qcm92aWRlckNvbmZpZxIsCgZlbmdpbmUYBSABKAsyHC5jcnlwdG90cmFkZXIuUHJvdmlkZXJDb25maWcSEgoKc3RhcnRfZGF0ZRgGIAEoCRIVCghlbmRfZGF0ZRgHIAEoCUgAiAEBEhUKDWJhcl9tYWduaWZpZXIYCCABKAkSEwoLcmVjYWxjdWxhdGUYCSABKA0SIAoTcmVjYWxjdWxhdGVfc2V0dGluZxgKIAEoCUgBiAEBEhAKCGFuYWx5c2VzGAsgAygJQgsKCV9lbmRfZGF0ZUIWChRfcmVjYWxjdWxhdGVfc2V0dGluZyJQChFQcmV2aWV3U3RyZWFtTGluaxILCgN1cmwYASABKAkSLgoKZXhwaXJlc19hdBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAymwYKDlByZXZpZXdTZXJ2aWNlElwKE0NyZWF0ZVByZXZpZXdTdHJlYW0SJC5jcnlwdG90cmFkZXIuUHJldmlld0JhY2t0ZXN0UmVxdWVzdBofLmNyeXB0b3RyYWRlci5QcmV2aWV3U3RyZWFtTGluaxJVCg9QcmV2aWV3QmFja3Rlc3QSJC5jcnlwdG90cmFkZXIuUHJldmlld0JhY2t0ZXN0UmVxdWVzdBocLmNyeXB0b3RyYWRlci5CYWNrdGVzdFJlc3VsdBJbCg9HZXRTdHJhdGVneUluZm8SJC5jcnlwdG90cmFkZXIuR2V0U3RyYXRlZ3lJbmZvUmVxdWVzdBoiLmNyeXB0b3RyYWRlci5TdHJhdGVneUluZm9SZXNwb25zZRJPChBHZXRNYXJrZXRTeW1ib2xzEhwuY3J5cHRvdHJhZGVyLlByb3ZpZGVyQ29uZmlnGh0uY3J5cHRvdHJhZGVyLlN5bWJvbHNSZXNwb25zZRJVChNHZXRNYXJrZXRUaW1lZnJhbWVzEhwuY3J5cHRvdHJhZGVyLlByb3ZpZGVyQ29uZmlnGiAuY3J5cHRvdHJhZGVyLlRpbWVmcmFtZXNSZXNwb25zZRJKChNHZXRDb25maWd1cmFibGVMaXN0EhMuY3J5cHRvdHJhZGVyLkVtcHR5Gh4uY3J5cHRvdHJhZGVyLkNvbmZpZ3VyYWJsZUxpc3QSVQoVR2V0Q29uZmlndXJhYmxlUGFyYW1zEh4uY3J5cHRvdHJhZGVyLkdldFBhcmFtc1JlcXVlc3QaHC5jcnlwdG90cmFkZXIuUGFyYW1zUmVzcG9uc2USVgoUVmFsaWRhdGVDb25maWd1cmFibGUSHi5jcnlwdG90cmFkZXIuR2V0UGFyYW1zUmVxdWVzdBoeLmNyeXB0b3RyYWRlci5WYWxpZGF0ZVJlc3BvbnNlElQKGEdldENvbmZpZ3VyYWJsZVByb3ZpZGVycxITLmNyeXB0b3RyYWRlci5FbXB0eRojLmNyeXB0b3RyYWRlci5Qcm92aWRlckluZm9zUmVzcG9uc2VCR1pFY29kZWJlcmcub3JnL0NyeXB0b1RyYWRlci9hcHAvcHJvdG8vZ2VuL2NyeXB0b3RyYWRlcnBiO2NyeXB0b3RyYWRlcnBiYgZwcm90bzM", [file_backtest, file_common, file_configurable, file_market, file_strategy, file_google_protobuf_timestamp]);

/**
 * @generated from message cryptotrader.GetStrategyInfoRequest
 */
export type GetStrategyInfoRequest = Message<"cryptotrader.GetStrategyInfoRequest"> & {
  /**
   * @generated from field: cryptotrader.ProviderConfig strategy = 1;
   */
  strategy?: ProviderConfig | undefined;
};

/**
 * Describes the message cryptotrader.GetStrategyInfoRequest.
 * Use `create(GetStrategyInfoRequestSchema)` to create a new message.
 */
export const GetStrategyInfoRequestSchema: GenMessage<GetStrategyInfoRequest> = /*@__PURE__*/
  messageDesc(file_preview, 0);

/**
 * @generated from message cryptotrader.PreviewBacktestRequest
 */
export type PreviewBacktestRequest = Message<"cryptotrader.PreviewBacktestRequest"> & {
  /**
   * @generated from field: cryptotrader.ProviderConfig market = 1;
   */
  market?: ProviderConfig | undefined;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: string timeframe = 3;
   */
  timeframe: string;

  /**
   * @generated from field: cryptotrader.ProviderConfig strategy = 4;
   */
  strategy?: ProviderConfig | undefined;

  /**
   * @generated from field: cryptotrader.ProviderConfig engine = 5;
   */
  engine?: ProviderConfig | undefined;

  /**
   * @generated from field: string start_date = 6;
   */
  startDate: string;

  /**
   * @generated from field: optional string end_date = 7;
   */
  endDate?: string | undefined;

  /**
   * empty = off
   *
   * @generated from field: string bar_magnifier = 8;
   */
  barMagnifier: string;

  /**
   * Explicit flags; zero means off for compatibility.
   *
   * @generated from field: uint32 recalculate = 9;
   */
  recalculate: number;

  /**
   * auto, off, on_order_fills, on_realtime_bars
   *
   * @generated from field: optional string recalculate_setting = 10;
   */
  recalculateSetting?: string | undefined;

  /**
   * monte_carlo, significance
   *
   * @generated from field: repeated string analyses = 11;
   */
  analyses: string[];
};

/**
 * Describes the message cryptotrader.PreviewBacktestRequest.
 * Use `create(PreviewBacktestRequestSchema)` to create a new message.
 */
export const PreviewBacktestRequestSchema: GenMessage<PreviewBacktestRequest> = /*@__PURE__*/
  messageDesc(file_preview, 1);

/**
 * @generated from message cryptotrader.PreviewStreamLink
 */
export type PreviewStreamLink = Message<"cryptotrader.PreviewStreamLink"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message cryptotrader.PreviewStreamLink.
 * Use `create(PreviewStreamLinkSchema)` to create a new message.
 */
export const PreviewStreamLinkSchema: GenMessage<PreviewStreamLink> = /*@__PURE__*/
  messageDesc(file_preview, 2);

/**
 * @generated from service cryptotrader.PreviewService
 */
export const PreviewService: GenService<{
  /**
   * Runs continue into live mode. end_date and analyses must be omitted.
   *
   * @generated from rpc cryptotrader.PreviewService.CreatePreviewStream
   */
  createPreviewStream: {
    methodKind: "unary";
    input: typeof PreviewBacktestRequestSchema;
    output: typeof PreviewStreamLinkSchema;
  },
  /**
   * @generated from rpc cryptotrader.PreviewService.PreviewBacktest
   */
  previewBacktest: {
    methodKind: "unary";
    input: typeof PreviewBacktestRequestSchema;
    output: typeof BacktestResultSchema;
  },
  /**
   * @generated from rpc cryptotrader.PreviewService.GetStrategyInfo
   */
  getStrategyInfo: {
    methodKind: "unary";
    input: typeof GetStrategyInfoRequestSchema;
    output: typeof StrategyInfoResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.PreviewService.GetMarketSymbols
   */
  getMarketSymbols: {
    methodKind: "unary";
    input: typeof ProviderConfigSchema;
    output: typeof SymbolsResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.PreviewService.GetMarketTimeframes
   */
  getMarketTimeframes: {
    methodKind: "unary";
    input: typeof ProviderConfigSchema;
    output: typeof TimeframesResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.PreviewService.GetConfigurableList
   */
  getConfigurableList: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ConfigurableListSchema;
  },
  /**
   * @generated from rpc cryptotrader.PreviewService.GetConfigurableParams
   */
  getConfigurableParams: {
    methodKind: "unary";
    input: typeof GetParamsRequestSchema;
    output: typeof ParamsResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.PreviewService.ValidateConfigurable
   */
  validateConfigurable: {
    methodKind: "unary";
    input: typeof GetParamsRequestSchema;
    output: typeof ValidateResponseSchema;
  },
  /**
   * @generated from rpc cryptotrader.PreviewService.GetConfigurableProviders
   */
  getConfigurableProviders: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ProviderInfosResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_preview, 0);

